var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_621_839",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 15,
    width: 14,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4375 15.7471H15.3151V31.6394H2.4375V15.7471Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_621_839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96697 29.1837L2.8676 30.0856C2.76506 30.1079 2.66252 30.0879 2.58675 30.0305C2.51065 29.9731 2.48292 29.8948 2.51032 29.8154L7.34295 15.9491C7.38391 15.8314 7.54223 15.7611 7.69507 15.7927L15.0445 17.3067C15.1976 17.3383 15.2889 17.4602 15.2479 17.5778L10.4156 31.4442C10.3882 31.5232 10.3131 31.5806 10.2099 31.6012C10.1067 31.6215 10.0048 31.5996 9.93065 31.5406L6.96697 29.1837Z",
    fill: "#B32030"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12646 29.8096L3.49219 29.9492L8.37705 15.9326L8.92329 16.0455L4.12646 29.8096Z",
    fill: "#F5C116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8242 17.0547L14.3704 17.1672L9.48587 31.1835L9.02734 30.8188L13.8242 17.0547Z",
    fill: "#F5C116"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3721 28.7129L10.962 29.8899L7.64844 18.0273L11.3721 28.7129Z",
    fill: "#8D1924"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8604 27.2427L10.5066 28.2578L10.2461 27.3249L10.5676 26.4023L10.8604 27.2427Z",
    fill: "#E1B015"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_621_839",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 15,
    width: 14,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48047 15.7471H20.2755V31.6394H7.48047V15.7471Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_621_839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7751 29.1837L19.8745 30.0856C19.977 30.1079 20.0796 30.0879 20.1557 30.0305C20.2314 29.9731 20.2592 29.8948 20.2318 29.8154L15.3994 15.9491C15.3585 15.8314 15.2002 15.7611 15.047 15.7927L7.69762 17.3067C7.54477 17.3383 7.45319 17.4602 7.49415 17.5778L12.3265 31.4442C12.3542 31.5232 12.4293 31.5806 12.5325 31.6012C12.6354 31.6215 12.7373 31.5996 12.8114 31.5406L15.7751 29.1837Z",
    fill: "#B32030"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6171 29.8096L19.2514 29.9492L14.3669 15.9326L13.8203 16.0455L18.6171 29.8096Z",
    fill: "#F5C116"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92156 17.0547L8.375 17.1672L13.2595 31.1835L13.7181 30.8188L8.92156 17.0547Z",
    fill: "#F5C116"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9739 0.975442L14.264 0.558504C14.697 0.418236 15.153 0.574627 15.409 0.95029L16.1081 1.97732L17.464 1.97861C17.9193 1.97893 18.3047 2.26817 18.4317 2.70478L18.7787 3.89691L20.0679 4.31642C20.5006 4.45734 20.7779 4.85138 20.7634 5.3054L20.7244 6.54654L21.8207 7.34301C22.1886 7.61065 22.3302 8.07079 22.1761 8.49837L21.7546 9.66631L22.5508 10.7623C22.8181 11.1303 22.81 11.6117 22.5311 11.9706L21.7688 12.9515L22.1867 14.2394C22.327 14.6718 22.1706 15.1271 21.794 15.3825L20.7653 16.0803L20.764 17.434C20.7637 17.8883 20.4738 18.2733 20.0366 18.4001L18.8422 18.7464L18.422 20.0333C18.2811 20.4654 17.8864 20.7421 17.4315 20.7279L16.1884 20.6889L15.3903 21.783C15.1224 22.1506 14.6613 22.2918 14.233 22.138L13.0628 21.7172L11.9652 22.512C11.5966 22.7787 11.1143 22.771 10.7547 22.4924L9.77187 21.7314L8.48206 22.1483C8.049 22.2886 7.59273 22.1325 7.3367 21.7565L6.63794 20.7295L5.28201 20.7282C4.82671 20.7279 4.44105 20.4386 4.31401 20.0024L3.96704 18.8099L2.67787 18.3904C2.24514 18.2495 1.96815 17.8558 1.98234 17.4014L2.02135 16.1606L0.925329 15.3638C0.557086 15.0962 0.415528 14.636 0.569984 14.2084L0.99111 13.0405L0.195292 11.9445C-0.0720234 11.5766 -0.0642844 11.0954 0.214639 10.7362L0.976922 9.75531L0.559343 8.46742C0.419075 8.035 0.575466 7.57969 0.95177 7.32431L1.98072 6.62651L1.98169 5.27283C1.98234 4.81849 2.2719 4.43348 2.70915 4.30675L3.90352 3.96043L4.32368 2.6735C4.46491 2.24141 4.8596 1.96474 5.31458 1.97893L6.55765 2.01795L7.35572 0.923849C7.62368 0.556247 8.08447 0.415011 8.51301 0.568823L9.68288 0.98963L10.7808 0.194772C11.1494 -0.0718997 11.6315 -0.0641608 11.9913 0.214442L12.9739 0.975442Z",
    fill: "#D69419"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2496 11.3539C21.2496 11.5155 21.2458 11.6767 21.2377 11.8379C21.23 11.9991 21.218 12.16 21.2022 12.3206C21.1864 12.4812 21.1664 12.6412 21.1429 12.8008C21.119 12.9607 21.0913 13.1197 21.06 13.2777C21.0284 13.436 20.993 13.5937 20.9536 13.7501C20.9143 13.9068 20.8714 14.0622 20.8243 14.2167C20.7776 14.3711 20.7266 14.5243 20.6721 14.6762C20.6176 14.8281 20.5596 14.9786 20.4977 15.1279C20.4358 15.2769 20.3703 15.4243 20.3013 15.5704C20.232 15.7161 20.1594 15.8602 20.0833 16.0028C20.0069 16.145 19.9272 16.2856 19.8444 16.4239C19.7612 16.5622 19.6748 16.6986 19.5848 16.8328C19.4952 16.9669 19.402 17.0988 19.3056 17.2284C19.2095 17.3581 19.1098 17.4854 19.0073 17.6102C18.9047 17.735 18.7993 17.8569 18.6906 17.9765C18.582 18.0962 18.4707 18.2132 18.3562 18.327C18.2421 18.4412 18.125 18.5524 18.0051 18.6611C17.8855 18.7695 17.7629 18.8746 17.6378 18.9771C17.513 19.0797 17.3857 19.1787 17.2557 19.2751C17.1258 19.3712 16.9939 19.464 16.8594 19.5537C16.7249 19.6433 16.5882 19.7297 16.4496 19.8126C16.3109 19.8955 16.1703 19.9751 16.0278 20.0512C15.8853 20.1273 15.7408 20.1999 15.5947 20.2689C15.4487 20.3379 15.3007 20.403 15.1514 20.4649C15.0021 20.5268 14.8512 20.5849 14.699 20.6391C14.5468 20.6936 14.3933 20.7442 14.2385 20.7909C14.084 20.8377 13.928 20.8809 13.7713 20.9199C13.6146 20.9593 13.4569 20.9947 13.2982 21.026C13.1396 21.0576 12.9803 21.0853 12.8203 21.1089C12.6604 21.1324 12.5001 21.1524 12.3392 21.1682C12.1783 21.184 12.0171 21.1959 11.8556 21.2037C11.6943 21.2118 11.5328 21.2156 11.3709 21.2156C11.2094 21.2156 11.0478 21.2118 10.8863 21.2037C10.7247 21.1959 10.5635 21.184 10.4026 21.1682C10.2417 21.1524 10.0814 21.1324 9.92148 21.1089C9.76154 21.0853 9.60225 21.0576 9.4436 21.026C9.28527 20.9947 9.12759 20.9593 8.97056 20.9199C8.81384 20.8809 8.6581 20.8377 8.50332 20.7909C8.34854 20.7442 8.19505 20.6936 8.04286 20.6391C7.89066 20.5849 7.73975 20.5268 7.59045 20.4649C7.44115 20.403 7.29347 20.3379 7.1474 20.2689C7.001 20.1999 6.85687 20.1273 6.71402 20.0512C6.57149 19.9751 6.4309 19.8955 6.29225 19.8126C6.15359 19.7297 6.01719 19.6433 5.88273 19.5537C5.74827 19.464 5.61606 19.3712 5.48611 19.2751C5.35648 19.1787 5.22879 19.0797 5.104 18.9771C4.97889 18.8746 4.85668 18.7695 4.73673 18.6611C4.6171 18.5524 4.50005 18.4412 4.38557 18.327C4.27142 18.2132 4.15986 18.0962 4.05119 17.9765C3.94284 17.8569 3.83708 17.735 3.73454 17.6102C3.632 17.4854 3.53268 17.3581 3.43627 17.2284C3.33985 17.0988 3.24699 16.9669 3.15702 16.8328C3.06738 16.6986 2.98096 16.5622 2.89777 16.4239C2.81457 16.2856 2.73493 16.145 2.65883 16.0028C2.58241 15.8602 2.50985 15.7161 2.44053 15.5704C2.37152 15.4243 2.30606 15.2769 2.24415 15.1279C2.18224 14.9786 2.1242 14.8281 2.0697 14.6762C2.01521 14.5243 1.96458 14.3711 1.91751 14.2167C1.87075 14.0622 1.82754 13.9068 1.7882 13.7501C1.74886 13.5937 1.71371 13.436 1.68211 13.2777C1.65051 13.1197 1.62278 12.9607 1.59924 12.8008C1.57538 12.6412 1.55571 12.4812 1.53991 12.3206C1.52379 12.16 1.51218 11.9991 1.50412 11.8379C1.49606 11.6767 1.49219 11.5155 1.49219 11.3539C1.49219 11.1924 1.49606 11.0311 1.50412 10.8699C1.51218 10.7087 1.52379 10.5478 1.53991 10.3872C1.55571 10.2266 1.57538 10.0667 1.59924 9.90704C1.62278 9.7471 1.65051 9.58813 1.68211 9.43012C1.71371 9.2718 1.74886 9.11411 1.7882 8.95772C1.82754 8.80101 1.87075 8.64558 1.91751 8.49113C1.96458 8.33667 2.01521 8.1835 2.0697 8.03162C2.1242 7.87975 2.18224 7.72916 2.24415 7.57986C2.30606 7.43089 2.37152 7.28352 2.44053 7.13745C2.50985 6.9917 2.58241 6.84756 2.65883 6.70503C2.73493 6.56283 2.81457 6.42256 2.89777 6.28391C2.98096 6.14557 3.06738 6.00917 3.15702 5.87503C3.24699 5.74089 3.33985 5.609 3.43627 5.47937C3.53268 5.34975 3.632 5.22238 3.73454 5.09758C3.83708 4.97279 3.94284 4.8509 4.05119 4.73127C4.15986 4.61164 4.27142 4.49459 4.38557 4.38076C4.50005 4.26661 4.6171 4.15536 4.73673 4.0467C4.85668 3.93835 4.97889 3.83323 5.104 3.73069C5.22879 3.62815 5.35648 3.52915 5.48611 3.43274C5.61606 3.33664 5.74827 3.24378 5.88273 3.15413C6.01719 3.06449 6.15359 2.97807 6.29225 2.8952C6.4309 2.81233 6.57149 2.73268 6.71402 2.65658C6.85687 2.58048 7.001 2.50793 7.1474 2.43892C7.29347 2.36992 7.44115 2.30478 7.59045 2.24287C7.73975 2.18096 7.89066 2.12291 8.04286 2.06874C8.19505 2.01425 8.34854 1.96362 8.50332 1.91686C8.6581 1.87011 8.81384 1.8269 8.97056 1.78788C9.12759 1.74854 9.28527 1.71307 9.4436 1.68179C9.60225 1.65019 9.76154 1.62246 9.92148 1.59892C10.0814 1.57538 10.2417 1.55539 10.4026 1.53959C10.5635 1.52379 10.7247 1.51186 10.8863 1.50412C11.0478 1.49606 11.2094 1.49219 11.3709 1.49219C11.5328 1.49219 11.6943 1.49606 11.8556 1.50412C12.0171 1.51186 12.1783 1.52379 12.3392 1.53959C12.5001 1.55539 12.6604 1.57538 12.8203 1.59892C12.9803 1.62246 13.1396 1.65019 13.2982 1.68179C13.4569 1.71307 13.6146 1.74854 13.7713 1.78788C13.928 1.8269 14.084 1.87011 14.2385 1.91686C14.3933 1.96362 14.5468 2.01425 14.699 2.06874C14.8512 2.12291 15.0021 2.18096 15.1514 2.24287C15.3007 2.30478 15.4487 2.36992 15.5947 2.43892C15.7408 2.50793 15.8853 2.58048 16.0278 2.65658C16.1703 2.73268 16.3109 2.81233 16.4496 2.8952C16.5882 2.97807 16.7249 3.06449 16.8594 3.15413C16.9939 3.24378 17.1258 3.33664 17.2557 3.43274C17.3857 3.52915 17.513 3.62815 17.6378 3.73069C17.7629 3.83323 17.8855 3.93835 18.0051 4.0467C18.125 4.15536 18.2421 4.26661 18.3562 4.38076C18.4707 4.49459 18.582 4.61164 18.6906 4.73127C18.7993 4.8509 18.9047 4.97279 19.0073 5.09758C19.1098 5.22238 19.2095 5.34975 19.3056 5.47937C19.402 5.609 19.4952 5.74089 19.5848 5.87503C19.6748 6.00917 19.7612 6.14557 19.8444 6.28391C19.9272 6.42256 20.0069 6.56283 20.0833 6.70503C20.1594 6.84756 20.232 6.9917 20.3013 7.13745C20.3703 7.28352 20.4358 7.43089 20.4977 7.57986C20.5596 7.72916 20.6176 7.87975 20.6721 8.03162C20.7266 8.1835 20.7776 8.33667 20.8243 8.49113C20.8714 8.64558 20.9143 8.80101 20.9536 8.95772C20.993 9.11411 21.0284 9.2718 21.06 9.43012C21.0913 9.58813 21.119 9.7471 21.1429 9.90704C21.1664 10.0667 21.1864 10.2266 21.2022 10.3872C21.218 10.5478 21.23 10.7087 21.2377 10.8699C21.2458 11.0311 21.2496 11.1924 21.2496 11.3539Z",
    fill: "#F2BB08"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3737 2.60059C13.795 2.60059 15.987 3.58021 17.5738 5.16412C19.1606 6.74836 20.1422 8.93655 20.1422 11.3537C20.1422 13.7708 19.1606 15.959 17.5738 17.5433C15.987 19.1272 13.795 20.1068 11.3737 20.1068C8.95235 20.1068 6.7603 19.1272 5.1735 17.5433C3.5867 15.959 2.60547 13.7708 2.60547 11.3537C2.60547 8.93655 3.5867 6.74836 5.1735 5.16412C6.7603 3.58021 8.95235 2.60059 11.3737 2.60059ZM17.41 5.32761C15.8651 3.78562 13.7311 2.83179 11.3737 2.83179C9.01651 2.83179 6.88219 3.78562 5.33731 5.32761C3.79242 6.86992 2.83699 9.0004 2.83699 11.3537C2.83699 13.707 3.79242 15.8375 5.33731 17.3798C6.88219 18.9218 9.01651 19.8756 11.3737 19.8756C13.7311 19.8756 15.8651 18.9218 17.41 17.3798C18.9549 15.8375 19.9103 13.707 19.9103 11.3537C19.9103 9.0004 18.9549 6.86992 17.41 5.32761Z",
    fill: "#D69419"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52344 15.7215C6.08677 16.3416 6.74264 16.478 7.50847 16.0394C6.93385 15.3826 6.26186 15.3429 5.52344 15.7215Z",
    fill: "#E9A306"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03125 14.6836C7.15249 15.4794 7.52428 16.1195 8.44908 16.4168C8.32075 15.4043 7.7758 14.9177 7.03125 14.6836Z",
    fill: "#E9A306"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57031 14.4612C4.95403 15.1455 5.53961 15.5112 6.47086 15.3303C5.98041 14.4986 5.32518 14.291 4.57031 14.4612Z",
    fill: "#E9A306"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08154 12.9268C5.8613 13.8151 6.06477 14.5861 6.7158 15.2336C6.98796 14.3562 6.74321 13.5949 6.08154 12.9268Z",
    fill: "#E9A306"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 12.9561C4.63135 13.62 4.96187 14.2198 5.87667 14.3097C5.63902 13.3946 5.08859 13.0309 4.375 12.9561Z",
    fill: "#E9A306"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55859 16.5784C7.1158 17.0905 7.73491 17.2865 8.48881 16.7974C8.53298 16.8193 8.58554 16.8502 8.65261 16.8896C8.80481 16.9786 8.94734 17.3252 9.11469 17.608C9.27624 17.8811 9.52582 18.062 9.69253 18.1336L9.81216 17.9904C9.52002 17.9395 9.29365 17.7018 9.13178 17.4687C9.01022 17.2933 8.91316 16.9831 8.69647 16.8296C8.63391 16.7854 8.59522 16.779 8.52267 16.7354C7.87582 16.0896 7.21543 16.2073 6.55859 16.5784Z",
    fill: "#E9A306"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67589 11.0859C6.02865 11.7828 6.06477 12.4986 5.62397 13.2429C5.25895 12.5238 5.24573 11.805 5.67589 11.0859Z",
    fill: "#E9A306"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14844 11.2969C4.191 12.0514 4.53216 12.6225 5.26091 12.9566C5.24994 12.1266 4.83785 11.6051 4.14844 11.2969Z",
    fill: "#E9A306"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40832 9.94727C4.31062 10.7402 4.4812 11.4203 5.13514 11.8978C5.3141 11.0549 5.01841 10.429 4.40832 9.94727Z",
    fill: "#E9A306"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36213 9.27734C6.35342 10.1193 6.04129 10.731 5.3364 11.0447C5.32157 10.2196 5.6624 9.63011 6.36213 9.27734Z",
    fill: "#E9A306"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68109 8.46094C5.33858 9.07909 5.35212 9.78205 5.18315 10.5089C4.65142 9.93747 4.43087 9.27095 4.68109 8.46094Z",
    fill: "#E9A306"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48732 7.90723C7.20711 8.74239 6.6815 9.169 5.91406 9.19351C6.17622 8.34061 6.70085 7.91271 7.48732 7.90723Z",
    fill: "#E9A306"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5092 7.25195C5.95902 8.01199 5.9084 8.77202 5.5092 9.53205C5.10548 8.76589 5.07614 8.00554 5.5092 7.25195Z",
    fill: "#E9A306"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54424 6.23535C6.81832 7.16242 6.61002 7.86666 6.04766 8.4071C5.83709 7.58193 5.96801 6.84867 6.54424 6.23535Z",
    fill: "#E9A306"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40672 6.77268C8.00816 7.6575 7.38712 7.87613 6.67578 7.8255C7.03435 7.06773 7.58639 6.67046 8.40672 6.77268Z",
    fill: "#E9A306"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9845 5.26758C7.92292 6.21818 7.50179 6.84375 6.76562 7.18362C6.80206 6.35426 7.17385 5.69774 7.9845 5.26758Z",
    fill: "#E9A306"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33494 5.1875C9.09729 6.02299 8.63231 6.57826 7.75781 6.62824C7.99095 5.77373 8.52687 5.30649 9.33494 5.1875Z",
    fill: "#E9A306"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2233 15.7215C16.6603 16.3416 16.0044 16.478 15.2383 16.0394C15.8129 15.3826 16.4852 15.3429 17.2233 15.7215Z",
    fill: "#E9A306"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7147 14.6836C15.5935 15.4794 15.2217 16.1195 14.2969 16.4168C14.4252 15.4043 14.9702 14.9177 15.7147 14.6836Z",
    fill: "#E9A306"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1779 14.4612C17.7938 15.1455 17.2086 15.5112 16.2773 15.3303C16.7675 14.4986 17.4227 14.291 18.1779 14.4612Z",
    fill: "#E9A306"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6656 12.9268C16.8855 13.8151 16.6821 14.5861 16.031 15.2336C15.7592 14.3562 16.004 13.5949 16.6656 12.9268Z",
    fill: "#E9A306"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3728 12.9561C18.1161 13.62 17.7859 14.2198 16.8711 14.3097C17.1087 13.3946 17.6589 13.0309 18.3728 12.9561Z",
    fill: "#E9A306"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1875 16.5784C15.6303 17.0905 15.0108 17.2865 14.2569 16.7974C14.2128 16.8193 14.1605 16.8502 14.0931 16.8896C13.9409 16.9786 13.7987 17.3252 13.6311 17.608C13.4695 17.8811 13.2199 18.062 13.0532 18.1336L12.9336 17.9904C13.2257 17.9395 13.4521 17.7018 13.614 17.4687C13.7355 17.2933 13.8326 16.9831 14.0493 16.8296C14.1118 16.7854 14.1509 16.779 14.2231 16.7354C14.8703 16.0896 15.5303 16.2073 16.1875 16.5784Z",
    fill: "#E9A306"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0685 11.0859C16.7158 11.7828 16.6797 12.4986 17.1204 13.2429C17.4858 12.5238 17.4987 11.805 17.0685 11.0859Z",
    fill: "#E9A306"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5972 11.2969C18.5546 12.0514 18.2131 12.6225 17.4844 12.9566C17.4953 12.1266 17.9074 11.6051 18.5972 11.2969Z",
    fill: "#E9A306"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.341 9.94727C18.4391 10.7402 18.2682 11.4203 17.6142 11.8978C17.4353 11.0549 17.731 10.429 18.341 9.94727Z",
    fill: "#E9A306"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3828 9.27734C16.3915 10.1193 16.7037 10.731 17.4085 11.0447C17.4237 10.2196 17.0825 9.63011 16.3828 9.27734Z",
    fill: "#E9A306"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.062 8.46094C17.4045 9.07909 17.391 9.78205 17.5596 10.5089C18.0913 9.93747 18.3122 9.27095 18.062 8.46094Z",
    fill: "#E9A306"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2617 7.90723C15.5419 8.74239 16.0675 9.169 16.8347 9.19351C16.5728 8.34061 16.0479 7.91271 15.2617 7.90723Z",
    fill: "#E9A306"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2404 7.25195C16.7906 8.01199 16.8415 8.77202 17.2404 9.53205C17.6441 8.76589 17.6738 8.00554 17.2404 7.25195Z",
    fill: "#E9A306"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2021 6.23535C15.9277 7.16242 16.1363 7.86666 16.6987 8.4071C16.9092 7.58193 16.7783 6.84867 16.2021 6.23535Z",
    fill: "#E9A306"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3398 6.77268C14.7387 7.6575 15.3598 7.87613 16.0708 7.8255C15.7122 7.06773 15.1602 6.67046 14.3398 6.77268Z",
    fill: "#E9A306"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7617 5.26758C14.8236 6.21818 15.2444 6.84375 15.9806 7.18362C15.9442 6.35426 15.5724 5.69774 14.7617 5.26758Z",
    fill: "#E9A306"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4141 5.1875C13.6517 6.02299 14.1167 6.57826 14.9912 6.62824C14.7577 5.77373 14.2218 5.30649 13.4141 5.1875Z",
    fill: "#E9A306"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6661 9.2249L14.8653 9.6499C14.9081 9.65829 14.9407 9.68666 14.9546 9.72794C14.9684 9.76889 14.9597 9.81113 14.931 9.8437L13.3594 11.6059L13.6338 13.8254C13.6393 13.8686 13.6222 13.9083 13.5874 13.9341C13.5522 13.9602 13.5093 13.965 13.4697 13.9476L11.305 12.9999L9.2755 13.9463C9.23584 13.9647 9.19295 13.9608 9.15748 13.9357C9.12201 13.9105 9.10395 13.8715 9.10814 13.828L9.34225 11.4802L7.81317 9.84563C7.7835 9.81403 7.77383 9.77179 7.78705 9.73052C7.79995 9.68892 7.83187 9.6599 7.87443 9.65055L10.1835 9.14719L11.2679 7.19052C11.2892 7.15247 11.3263 7.13022 11.3698 7.1299C11.4134 7.12925 11.4508 7.15053 11.473 7.18794L12.6661 9.22458V9.2249Z",
    fill: "#E9A306"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52344 15.4441C6.08677 16.0642 6.74264 16.2006 7.50847 15.7621C6.93385 15.1052 6.26186 15.0656 5.52344 15.4441Z",
    fill: "#FDF19D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03125 14.4062C7.15249 15.2021 7.52428 15.8422 8.44908 16.1398C8.32075 15.1269 7.7758 14.6404 7.03125 14.4062Z",
    fill: "#FDF19D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57031 14.1829C4.95403 14.8672 5.53961 15.2332 6.47086 15.0523C5.98041 14.2203 5.32518 14.0127 4.57031 14.1829Z",
    fill: "#FDF19D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08154 12.6494C5.8613 13.5375 6.06477 14.3088 6.7158 14.956C6.98796 14.0785 6.74321 13.3172 6.08154 12.6494Z",
    fill: "#FDF19D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 12.6787C4.63135 13.3427 4.96187 13.9424 5.87667 14.0324C5.63902 13.1173 5.08859 12.7535 4.375 12.6787Z",
    fill: "#FDF19D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55859 16.3009C7.1158 16.813 7.73491 17.0091 8.48881 16.5199C8.53298 16.5418 8.58554 16.5731 8.65261 16.6121C8.80481 16.7011 8.94734 17.0477 9.11469 17.3309C9.27624 17.6037 9.52582 17.7849 9.69253 17.8565L9.81216 17.7133C9.52002 17.662 9.29365 17.4244 9.13178 17.1912C9.01022 17.0161 8.91316 16.7056 8.69647 16.5521C8.63391 16.508 8.59522 16.5015 8.52267 16.458C7.87582 15.8121 7.21543 15.9301 6.55859 16.3009Z",
    fill: "#FDF19D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67589 10.8076C6.02865 11.5041 6.06477 12.22 5.62397 12.9642C5.25895 12.2455 5.24573 11.5264 5.67589 10.8076Z",
    fill: "#FDF19D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14844 11.0195C4.191 11.7741 4.53216 12.3455 5.26091 12.6792C5.24994 11.8495 4.83785 11.3278 4.14844 11.0195Z",
    fill: "#FDF19D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40832 9.66992C4.31062 10.4628 4.4812 11.1429 5.13514 11.6205C5.3141 10.7776 5.01841 10.1517 4.40832 9.66992Z",
    fill: "#FDF19D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36213 9C6.35342 9.84194 6.04129 10.4536 5.3364 10.7677C5.32157 9.94254 5.6624 9.35277 6.36213 9Z",
    fill: "#FDF19D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68109 8.18164C5.33858 8.80011 5.35212 9.50275 5.18315 10.2296C4.65142 9.65817 4.43087 8.99165 4.68109 8.18164Z",
    fill: "#FDF19D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48732 7.62988C7.20711 8.46505 6.6815 8.89166 5.91406 8.91617C6.17622 8.06327 6.70085 7.63536 7.48732 7.62988Z",
    fill: "#FDF19D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5092 6.97363C5.95902 7.73367 5.9084 8.4937 5.5092 9.25405C5.10548 8.48789 5.07614 7.72722 5.5092 6.97363Z",
    fill: "#FDF19D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54424 5.95703C6.81832 6.8841 6.61002 7.58834 6.04766 8.12878C5.83709 7.30361 5.96801 6.57035 6.54424 5.95703Z",
    fill: "#FDF19D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40672 6.49533C8.00816 7.38016 7.38712 7.59911 6.67578 7.54816C7.03435 6.79038 7.58639 6.39311 8.40672 6.49533Z",
    fill: "#FDF19D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9845 4.99023C7.92292 5.94084 7.50179 6.56641 6.76562 6.90628C6.80206 6.07692 7.17385 5.42072 7.9845 4.99023Z",
    fill: "#FDF19D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33494 4.91016C9.09729 5.74564 8.63231 6.30092 7.75781 6.35122C7.99095 5.49638 8.52687 5.02914 9.33494 4.91016Z",
    fill: "#FDF19D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2233 15.4441C16.6603 16.0642 16.0044 16.2006 15.2383 15.7621C15.8129 15.1052 16.4852 15.0656 17.2233 15.4441Z",
    fill: "#FDF19D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7147 14.4062C15.5935 15.2021 15.2217 15.8422 14.2969 16.1398C14.4252 15.1269 14.9702 14.6404 15.7147 14.4062Z",
    fill: "#FDF19D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1779 14.1829C17.7938 14.8672 17.2086 15.2332 16.2773 15.0523C16.7675 14.2203 17.4227 14.0127 18.1779 14.1829Z",
    fill: "#FDF19D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6656 12.6494C16.8855 13.5375 16.6821 14.3088 16.031 14.956C15.7592 14.0785 16.004 13.3172 16.6656 12.6494Z",
    fill: "#FDF19D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3728 12.6787C18.1161 13.3427 17.7859 13.9424 16.8711 14.0324C17.1087 13.1173 17.6589 12.7535 18.3728 12.6787Z",
    fill: "#FDF19D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1875 16.3009C15.6303 16.813 15.0108 17.0091 14.2569 16.5199C14.2128 16.5418 14.1605 16.5731 14.0931 16.6121C13.9409 16.7011 13.7987 17.0477 13.6311 17.3309C13.4695 17.6037 13.2199 17.7849 13.0532 17.8565L12.9336 17.7133C13.2257 17.662 13.4521 17.4244 13.614 17.1912C13.7355 17.0161 13.8326 16.7056 14.0493 16.5521C14.1118 16.508 14.1509 16.5015 14.2231 16.458C14.8703 15.8121 15.5303 15.9301 16.1875 16.3009Z",
    fill: "#FDF19D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0685 10.8076C16.7158 11.5041 16.6797 12.22 17.1204 12.9642C17.4858 12.2455 17.4987 11.5264 17.0685 10.8076Z",
    fill: "#FDF19D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5972 11.0195C18.5546 11.7741 18.2131 12.3455 17.4844 12.6792C17.4953 11.8495 17.9074 11.3278 18.5972 11.0195Z",
    fill: "#FDF19D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.341 9.66992C18.4391 10.4628 18.2682 11.1429 17.6142 11.6205C17.4353 10.7776 17.731 10.1517 18.341 9.66992Z",
    fill: "#FDF19D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3828 9C16.3915 9.84194 16.7037 10.4536 17.4085 10.7677C17.4237 9.94254 17.0825 9.35277 16.3828 9Z",
    fill: "#FDF19D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.062 8.18164C17.4045 8.80011 17.391 9.50275 17.5596 10.2296C18.0913 9.65817 18.3122 8.99165 18.062 8.18164Z",
    fill: "#FDF19D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2617 7.62988C15.5419 8.46505 16.0675 8.89166 16.8347 8.91617C16.5728 8.06327 16.0479 7.63536 15.2617 7.62988Z",
    fill: "#FDF19D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2404 6.97363C16.7906 7.73367 16.8415 8.4937 17.2404 9.25405C17.6441 8.48789 17.6738 7.72722 17.2404 6.97363Z",
    fill: "#FDF19D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2021 5.95703C15.9277 6.8841 16.1363 7.58834 16.6987 8.12878C16.9092 7.30361 16.7783 6.57035 16.2021 5.95703Z",
    fill: "#FDF19D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3398 6.49533C14.7387 7.38016 15.3598 7.59911 16.0708 7.54816C15.7122 6.79038 15.1602 6.39311 14.3398 6.49533Z",
    fill: "#FDF19D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7617 4.99023C14.8236 5.94084 15.2444 6.56641 15.9806 6.90628C15.9442 6.07692 15.5724 5.42072 14.7617 4.99023Z",
    fill: "#FDF19D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4141 4.91016C13.6517 5.74564 14.1167 6.30092 14.9912 6.35122C14.7577 5.49638 14.2218 5.02914 13.4141 4.91016Z",
    fill: "#FDF19D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6661 8.94658L14.8653 9.3719C14.9081 9.37997 14.9407 9.40834 14.9546 9.44962C14.9684 9.49089 14.9597 9.53313 14.931 9.56538L13.3594 11.3276L13.6338 13.5471C13.6393 13.5903 13.6222 13.63 13.5874 13.6558C13.5522 13.6819 13.5093 13.6867 13.4697 13.6693L11.305 12.7216L9.2755 13.668C9.23584 13.6864 9.19295 13.6825 9.15748 13.6574C9.12201 13.6325 9.10395 13.5932 9.10814 13.55L9.34225 11.2018L7.81317 9.56764C7.7835 9.53571 7.77383 9.49379 7.78705 9.4522C7.79995 9.4106 7.83187 9.38158 7.87443 9.37223L10.1835 8.86887L11.2679 6.9122C11.2892 6.87415 11.3263 6.85222 11.3698 6.85158C11.4134 6.85093 11.4508 6.87221 11.473 6.90994L12.6661 8.94658Z",
    fill: "#FDF19D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1875 8.86886L11.2722 6.91218C11.2935 6.87413 11.3306 6.85221 11.3741 6.85156L11.3754 10.5431L10.1875 8.86886Z",
    fill: "#F7AE11"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15931 13.6582C9.12384 13.6334 9.10578 13.5941 9.10997 13.5509L9.34407 11.2027L11.373 10.5439L9.15931 13.6582Z",
    fill: "#E9A306"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.359 11.3285L13.6335 13.548C13.6386 13.5912 13.6218 13.6308 13.587 13.6566C13.5519 13.6827 13.509 13.6876 13.4693 13.6702L11.3047 12.7225L11.3708 10.5439L13.359 11.3285Z",
    fill: "#FEDF2C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.587 13.6566C13.5519 13.6827 13.509 13.6876 13.4693 13.6702L11.3047 12.7225L11.3708 10.5439L13.587 13.6566Z",
    fill: "#D69419"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34225 11.2024L7.81317 9.56791C7.7835 9.53598 7.77383 9.49406 7.78705 9.45247C7.79995 9.41119 7.83187 9.38185 7.87443 9.3725L10.1832 8.86914L11.3711 10.5433L9.34225 11.2024Z",
    fill: "#FEDF2C"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78906 9.45247C7.80196 9.41119 7.83388 9.38185 7.87645 9.3725L10.1852 8.86914L11.3731 10.5433L7.78906 9.45247Z",
    fill: "#FDF19D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6661 8.94754L14.8652 9.37287C14.9081 9.38093 14.9407 9.4093 14.9545 9.45058L11.3711 10.544V6.85254C11.414 6.85254 11.4511 6.87382 11.4727 6.9109L12.6661 8.94754Z",
    fill: "#FEDF2C"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6661 8.94727L14.8652 9.37259C14.9081 9.38065 14.9407 9.40902 14.9545 9.4503L11.3711 10.5438L12.6661 8.94727Z",
    fill: "#F7AE11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/Gold.b8167944750d6f280ccccba9a42f82d4.svg";
export { ForwardRef as ReactComponent };